var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgChannelGoogleplus = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 64,
  height: 41,
  viewBox: "0 0 64 41",
  role: "img"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FF3CA0",
  fillRule: "evenodd",
  d: "M20.327 0c5.268 0 10.067 2.02 13.679 5.336-3.168 3.017-3.9 3.92-4.757 4.881l-.149.166a27 27 0 0 1-.88.93c-2.09-1.741-4.367-2.991-7.893-2.991-6.669 0-11.874 5.452-11.874 12.178s5.205 12.178 11.874 12.178c6.59 0 9.268-2.866 10.99-8.13l-.595.001h-1.666l-.261.001-1.087.001h-.842l-.283.001h-.847l-.28.001h-.554l-.273.001h-.534l-.26.001h-.75l-.237.001h-.452l-.213.001-.761.001h-.701l-.101.001h-.293v-8.118h19.522C41.21 26.264 37.107 41 20.327 41 9.101 41 0 31.822 0 20.5S9.1 0 20.327 0m36.629 9.743v7.104H64v5.074h-7.044v7.307h-5.031V21.92h-7.246v-5.074h7.246V9.743z"
})));
export default SvgChannelGoogleplus;